import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideHelperForm from '../containers/CareGuideHelperFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideHelperAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideHelperAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_helper_route_add')} />
          <CareGuideHelperForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideHelperAddScreen;

Logger.log('silly', `CareGuideHelperAddScreen loaded.`);
